module.exports = __webpack_public_path__ + "static/media/grain.72464563.png";